/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { spacing } from '../../shared/theme/spacing';
import { ticketColors, ticketFonts } from '../../shared/theme/ticketColors';
import { useOwnerPanelAccess } from '../hooks/useOwnerPanelAccess';

type Props = {
  onPress: () => void;
};

/** Card en Inicio cuando hay ≥2 sucursales y el usuario es dueño. */
export function OwnerPanelHomeCard({ onPress }: Props) {
  const { canAccessOwnerPanel, activeBranchCount } = useOwnerPanelAccess();
  if (!canAccessOwnerPanel) return null;

  return (
    <TouchableOpacity
      style={styles.card}
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel="Ver todas mis sucursales"
      testID="home.owner-panel.cta"
    >
      <View style={styles.iconWrap}>
        <Ionicons name="business-outline" size={20} color={ticketColors.gold} />
      </View>
      <View style={styles.textWrap}>
        <Text style={styles.title}>Ver todas mis sucursales</Text>
        <Text style={styles.sub}>
          Panel del dueño · {activeBranchCount} local{activeBranchCount === 1 ? '' : 'es'} · ventas, caja y alertas
        </Text>
      </View>
      <Ionicons name="chevron-forward" size={18} color={ticketColors.ink2} />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.md,
    backgroundColor: ticketColors.brandSoft,
    borderRadius: 16,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: ticketColors.gold,
    padding: spacing.md,
  },
  iconWrap: {
    width: 40,
    height: 40,
    borderRadius: 10,
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
    justifyContent: 'center',
  },
  textWrap: { flex: 1, gap: 2 },
  title: {
    fontFamily: ticketFonts.sans,
    fontWeight: '700',
    fontSize: 14,
    color: ticketColors.gold,
  },
  sub: {
    fontFamily: ticketFonts.sans,
    fontSize: 12.5,
    color: ticketColors.ink2,
    lineHeight: 17,
  },
});
